import { Link, createFileRoute } from '@tanstack/react-router';
import { Image } from '@unpic/react';
import { getCollections } from '../../server/catalog.functions';
import { seo } from '../../utils/seo';

export const Route = createFileRoute('/_layout/products')({
  loader: () => getCollections(),
  head: () => ({ meta: seo({ title: 'Termékek' }) }),
  component: ProductsRoute
});

/** The list of product collections. */
function ProductsRoute() {
  const collections = Route.useLoaderData();

  return (
    <div className="container-fluid">
      <div className="page-content centered">
        <h1 className="page-title">Termékek</h1>
        <ul className="product-list">
          {collections.map(collection => (
            <li key={collection.id} className="product-list-item">
              <Link to="/$handle" params={{ handle: collection.handle }}>
                {collection.image && (
                  <Image
                    src={collection.image.url}
                    layout="fullWidth"
                    aspectRatio={1}
                    priority // Eagerly load the featured products images for better performance and SEO
                    alt={`${collection.title} kollekció`}
                  />
                )}
                <h3 className="product-list-item-title">{collection.title}</h3>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
